module.exports = __webpack_public_path__ + "static/media/obeya.4631f37e.mp3";